<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <v-row>
      <v-col
        cols="12"
        class="text-center subheading pt-0 mb-1"
        style="font-weight: 500;"
      ><span v-if='countrySelected === false'>Most </span>New Cases Trend (5-Day Moving Average)</v-col>
    </v-row>
    <v-row style="height: 100%;" class="pa-3 pt-0">
      <v-col cols="12" :md="countrySelected === false? 6: 12" v-for="(item, index) in items" :key="item.country" class="pa-0 ma-0 mb-3">
        <div class="ma-2 mb-0 mt-0" v-bind:style="{ 'min-height': $vuetify.breakpoint.lg? '152px !important': 'inherit', 'background-color': 'rgb(23 42 73)' }">
          <div class="pa-3 pb-0">
            <div class="grey--text text--lighten-1">{{item.country}}</div>
          </div>
          <v-row class="pl-3 pr-3">
            <v-col :cols="countrySelected === false? 8: 10">
              <apexchart type="bar" :height="countrySelected === false? 50: 200" :options="chartOptions" :series="item.series" :ref="'chart_'+ index" />
            </v-col>
            <v-col :cols="countrySelected === false? 4: 2" class="mt-3">
              <div v-if="item.delta === 'up'">
                <v-icon dark color="pink lighten-2" size="22">arrow_drop_up</v-icon>
                <span class="caption pink--text text--lighten-2" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">UP</span>
              </div>
              <div v-if="item.delta === 'down'">
                <v-icon dark color="green" size="22">arrow_drop_down</v-icon>
                <span class="caption green--text" v-bind:style="{ 'font-size': $vuetify.breakpoint.lg? '10px !important': 'inherit' }">DOWN</span>
              </div>            
            </v-col>
          </v-row>
          <div class="pa-3 ml-5 pt-0">
            <div class="caption blue--text text--lighten-2">{{'+ ' + getNumberDisplay(item.latestAverage) + ' average'}}</div>
          </div>
        </div>
      </v-col>
    </v-row>
</div>
</template>

<script>
export default {
  name: "NewCaseTrend",
  data: () => ({
    items: [],
    countrySelected: false,
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10",
      },
      colors: [
        "#e91e63",
        "#008FFB",
        "#008FFB",
        "#F86624",
        "#4CAF50",
        "#d6c51b"
      ],
      chart: {
        animations: {
          enabled: false
        },
        background: "rgb(23 42 73)",
        foreColor: "rgb(212, 212, 212)",
        sparkline: {
          enabled: true
        }
      },
      tooltip: {
        x: {
          show: true,
          format: "dd MMM",
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [0],
        style: {
          //fontSize: "12px",
          colors: ["#fff"],
        },
        background: {
          enabled: false,
        },
      },
      xaxis: {
        type: "datetime",
        //categories: [],
        labels: {
          style: {
            fontSize: "10px",
          },
        },
      }
    },
  }),
  methods: {
    loadCases(data, countryDisplay) {
      //clear data
      this.items = [];

      //check no data
      if (data.length === 0) {
        return;
      }

      if(countryDisplay && countryDisplay !== "") {
        this.countrySelected = true
      }
      else {
        this.countrySelected = false
      }

      //first calculate the latest 5 day avg to get the top 4 so don't have to loop through all data
      var topcountries = [];
      for (var i = 0; i < data.length; i++) {
        
        //get  the last date
        var lastDate = data[i].cases[data[i].cases.length - 1].date
        lastDate = this.$moment(lastDate, "YYYY-MM-DD")

        //substract 2 days so that we have 2 next days
        lastDate = lastDate.subtract(2, "days")

        //now calc the last average
        //set the dates
        var ddaysago2 = lastDate.clone().subtract(2, "days").format("YYYY-MM-DD")
        var ddaysago1 = lastDate.clone().subtract(1, "days").format("YYYY-MM-DD")
        var dtoday = lastDate.clone().format("YYYY-MM-DD")
        var ddaysnext1 = lastDate.clone().add(1, "days").format("YYYY-MM-DD")
        var ddaysnext2 = lastDate.clone().add(2, "days").format("YYYY-MM-DD")

        //get the newcases counts
        var daysago2 = this.getNewCasesForDay(ddaysago2, data[i].cases)
        var daysago1 = this.getNewCasesForDay(ddaysago1, data[i].cases)
        var today = this.getNewCasesForDay(dtoday, data[i].cases)
        var daysnext1 = this.getNewCasesForDay(ddaysnext1, data[i].cases)
        var daysnext2 = this.getNewCasesForDay(ddaysnext2, data[i].cases)

        //get the average
        var avg = (daysago2 + daysago1 + today + daysnext1 + daysnext2)/5 
        avg = parseFloat(avg.toFixed(0))

        topcountries.push({
          country: data[i].Country_WHO,
          latestAverage: avg,
          data: data[i]
        });
      }

      //sort by count desc
      topcountries = topcountries.sort(function (a, b) {
        a = a.latestAverage;
        b = b.latestAverage;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //only take the top 10
      topcountries = topcountries.slice(0, 4);

      //loop through top 4 and calculate it's 5 day moving average
      //this is calculated for each day by averaging the values of that day, the two days before, and the two next days
      var countries = [];
      for (var i = 0; i < topcountries.length; i++) {
        
        var tdata = topcountries[i].data

        //first get the first case date
        var firstDate =  tdata.cases[0].date
        firstDate = this.$moment(firstDate, "YYYY-MM-DD")

        //add 2 days so that we have 2 prev days
        firstDate = firstDate.add(2, "days")

        //then get  the last date
        var lastDate = tdata.cases[tdata.cases.length - 1].date
        lastDate = this.$moment(lastDate, "YYYY-MM-DD")

        //substract 2 days so that we have 2 next days
        lastDate = lastDate.subtract(2, "days")

        //now loop through every date from the first date to the last date and calculate the average
        var averages = []

        while (firstDate.isSameOrBefore(lastDate)) {

          //set the dates
          var ddaysago2 = firstDate.clone().subtract(2, "days").format("YYYY-MM-DD")
          var ddaysago1 = firstDate.clone().subtract(1, "days").format("YYYY-MM-DD")
          var dtoday = firstDate.clone().format("YYYY-MM-DD")
          var ddaysnext1 = firstDate.clone().add(1, "days").format("YYYY-MM-DD")
          var ddaysnext2 = firstDate.clone().add(2, "days").format("YYYY-MM-DD")

          //get the newcases counts
          var daysago2 = this.getNewCasesForDay(ddaysago2, tdata.cases)
          var daysago1 = this.getNewCasesForDay(ddaysago1, tdata.cases)
          var today = this.getNewCasesForDay(dtoday, tdata.cases)
          var daysnext1 = this.getNewCasesForDay(ddaysnext1, tdata.cases)
          var daysnext2 = this.getNewCasesForDay(ddaysnext2, tdata.cases)

          //get the average
          var avg = (daysago2 + daysago1 + today + daysnext1 + daysnext2)/5 
          avg = parseFloat(avg.toFixed(0))
          averages.push({date: dtoday, average: avg})

          //go to the next day
          firstDate = firstDate.add(1, "days")
        }
      
        var latestAverage = averages[averages.length - 1].average;

        countries.push({
          country: tdata.Country_WHO,
          latestAverage: latestAverage,
          averages: averages
        });
      }

      //sort by count desc
      countries = countries.sort(function (a, b) {
        a = a.latestAverage;
        b = b.latestAverage;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //set the graph data
      var self = this
      for (var i = 0; i < countries.length; i++) {
        var vals = []

        vals = countries[i].averages.map(function(obj) {
          return [
            self.$moment(obj.date, "YYYY-MM-DD")
              .add(10, "hours")
              .toDate(),
            obj.average
          ]
        })

        //set the series 
        countries[i].series = [{
          name: "Avg. New Cases",
          type: "column",
          data: vals
        }]    
        
        //calculate if the delta is up or down
        var prevAverage = countries[i].averages[countries[i].averages.length - 2].average
        
        if(countries[i].latestAverage >= prevAverage)
        {
          //up
          countries[i].delta = "up"
        }
        else {
          //down
          countries[i].delta = "down"
        }
      }

      this.items = countries;

    },
    getNumberDisplay(number) {
      return number.toLocaleString("en").replace(/\,/g, " ");
    },
    getNewCasesForDay(date, cases) {
      var change = 0
      
      var match = cases.find(c => c.date === date)
      if(match) {
        change = match.new_cases
      }

      return change
    },
    resize() {
      let self = this;

      if(self.$refs["chart_0"]) {
        self.$refs["chart_0"][0].refresh()
      }

      if(self.$refs["chart_1"]) {
        self.$refs["chart_1"][0].refresh()
      }

      if(self.$refs["chart_2"]) {
        self.$refs["chart_2"][0].refresh()
      }

      if(self.$refs["chart_3"]) {
        self.$refs["chart_3"][0].refresh()
      }  
      
      // this.$nextTick().then(function() {
      //   self.chartOptions = {
      //     chart: {
      //       height: (self.countrySelected === false)? 50: 200,
      //       width: '100%'
      //     }
      //   };
      // });
    }
  },
};
</script>